// biome-ignore lint/correctness/noUnusedImports: <explanation>
import type dayjs from 'dayjs';
import { useTranslations } from '@power-core/toolkit';
import { useDate } from './use-date';

export const useDropdownDateOptions = () => {
	const { dayjs, format } = useDate();
	const t = useTranslations();

	const getStartByUnit = (unit: dayjs.OpUnitType) => {
		return dayjs(new Date()).startOf(unit);
	};

	const getEndByUnit = (unit: dayjs.OpUnitType) => {
		return dayjs(new Date()).endOf(unit);
	};

	const startOfDayShort = format(getStartByUnit('day'), 'DD/MM');
	const endOfDayShort = format(getEndByUnit('day'), 'DD/MM');
	const startOfWeekShort = format(getStartByUnit('week'), 'DD/MM');
	const endOfWeekShort = format(getEndByUnit('week'), 'DD/MM');
	const month = format(getStartByUnit('month'), 'MMMM');
	const year = format(getStartByUnit('year'), 'YYYY');

	const dateOptions = [
		{
			label: `${t('T_TODAY')} (${startOfDayShort} - ${endOfDayShort})`,
			value: { from: getStartByUnit('day').toISOString(), to: getEndByUnit('day').toISOString() },
		},
		{
			label: `${t('T_CURRENT_WEEK')} (${startOfWeekShort} - ${endOfWeekShort})`,
			value: { from: getStartByUnit('week').toISOString(), to: getEndByUnit('week').toISOString() },
		},
		{
			label: `${t('T_CURRENT_MONTH')} (${month})`,
			value: { from: getStartByUnit('month').toISOString(), to: getEndByUnit('month').toISOString() },
		},
		{
			label: `${t('T_CURRENT_YEAR')} (${year})`,
			value: { from: getStartByUnit('year').toISOString(), to: getEndByUnit('year').toISOString() },
		},
		{ label: `${t('T_SET_PERIOD')}`, value: 'SET_PERIOD', range: true },
	];

	return {
		dateOptions,
	};
};
